export default __webpack_public_path__ + "static/media/v1.d73d88bb.jpg";